(() => {
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-origin-consent-open]');
    if (!control) return;
    event.preventDefault();
    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
    } else {
      window.location.href = `${window.Shopify?.routes?.root || '/'}policies/privacy-policy`;
    }
  });
})();
